import React, { Component } from "react";
import ApprovalConf from "../../../components/ApprovalConf/ApprovalConf";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AApprovalConfForm
Description : Componente que invoca al componente ApprovalConf.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class ApprovalConfForm extends Component {
    render() {
        return (
            <ApprovalConf />
        )
    }
}

export default ApprovalConfForm;